import type { BusinessCaseKind, InvestigationFinding, InvestigationRound } from '@/frontend/features/Fde/investigations/types'

const businessKinds: BusinessCaseKind[] = ['opportunity', 'diagnostic', 'data_gap', 'not_supported']

/** Only the swarm's typed business case sets the category. Legacy prose and
 * confidence/status are never promoted to opportunities by UI heuristics.
 */
export function businessCaseGroups(findings: InvestigationFinding[]) {
  const groups: Record<BusinessCaseKind | 'legacy' | 'unavailable', InvestigationFinding[]> = {
    opportunity: [], diagnostic: [], data_gap: [], not_supported: [], legacy: [], unavailable: [],
  }
  findings.forEach((finding) => {
    const kind = finding.business_case?.kind
    if (finding.case_state === 'bound' && kind && businessKinds.includes(kind)) groups[kind].push(finding)
    else if (finding.case_state === 'legacy' || (!finding.case_state && !finding.business_case)) groups.legacy.push(finding)
    else groups.unavailable.push(finding)
  })
  return groups
}

export const directContinuation = (runId: string, rounds: InvestigationRound[]) => rounds.find((round) => round.parent_id === runId)

export function businessCell(value: unknown, missing: string, emptyList: string): string {
  if (value === null || value === undefined) return missing
  if (Array.isArray(value) && value.every((item) => item === null || ['string', 'number', 'boolean'].includes(typeof item))) {
    return value.length === 0 ? emptyList : value.map((item) => businessCell(item, missing, emptyList)).join(' · ')
  }
  // Formatting never infers percentages, currency, units or new aggregates.
  if (typeof value === 'number') return Number.isFinite(value) ? value.toLocaleString('pt-BR', { maximumFractionDigits: 20 }) : missing
  return typeof value === 'object' ? JSON.stringify(value) : String(value)
}

/** Layout only: keep date-shaped values together without parsing, normalizing
 * or converting the timestamp/timezone supplied by the evidence journal.
 */
export function isIsoDateCell(value: unknown): boolean {
  return typeof value === 'string' && /^\d{4}-\d{2}-\d{2}(?:[T ]\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?(?:Z|[+-]\d{2}:?\d{2})?)?$/.test(value)
}
